import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { getCoachByUid } from './firebaseUtils';

// Admin user IDs (full admin – separate from coach accounts)
export const ADMIN_USERS = {
  'w4JeMlHRtue6uPPAZKeOgLfKJkL2': {
    uid: 'w4JeMlHRtue6uPPAZKeOgLfKJkL2',
    email: 'info@tenisouzsiemimai.lt',
    role: 'admin',
    name: 'TenisoUžsiėmimai.lt'
  }
};

// Coach UIDs (Julija, Vitalijus – listed here for backwards compat; COACHES in firebaseUtils is source of truth)
export const COACH_UIDS = [
  'y51Y9x1UdVRp1h3MvE3FyHhRVZ32', // Julija Baltuškienė
  'mQTBgMVx18hzvl84boWQQcIKvOk2'  // Vitalijus Dūda
];

// Check if user is admin
export const isUserAdmin = (user) => {
  if (!user || !user.uid) return false;
  return ADMIN_USERS.hasOwnProperty(user.uid);
};

// Check if user is a coach (in COACHES, admin, COACH_UIDS, or approved from Firestore)
export const isCoach = (user, approvedCoachUids = []) => {
  if (!user || !user.uid) return false;
  return (
    getCoachByUid(user.uid) != null ||
    ADMIN_USERS.hasOwnProperty(user.uid) ||
    COACH_UIDS.includes(user.uid) ||
    (Array.isArray(approvedCoachUids) && approvedCoachUids.includes(user.uid))
  );
};

// Get admin user info
export const getAdminUserInfo = (uid) => {
  return ADMIN_USERS[uid] || null;
};

// Create admin user document in Firestore (for future role management)
export const createAdminUserDocument = async (uid, userData) => {
  try {
    const userRef = doc(db, 'users', uid);
    await setDoc(userRef, {
      ...userData,
      role: 'admin',
      createdAt: new Date(),
      updatedAt: new Date()
    });
  } catch (error) {
    console.error('Error creating admin user document:', error);
  }
};

// Get user role from Firestore (for future role management)
export const getUserRole = async (uid) => {
  try {
    const userRef = doc(db, 'users', uid);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      return userDoc.data().role || 'user';
    }
    
    // Check if it's a hardcoded admin
    if (ADMIN_USERS[uid]) {
      return 'admin';
    }
    
    return 'user';
  } catch (error) {
    console.error('Error getting user role:', error);
    return 'user';
  }
}; 